import { TableCell } from '@material-ui/core';
import React, { useEffect } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import DataTable from '../../../../components/DataTable_v2/DataTable';
import usePagination from '../../../../hooks/usePagination';

const ItemsList = ({ data, loading, count, refresh }) => {
  const { page, onChangePage, rowsPerPage, onChangeRowsPerPage } = usePagination({});

  useEffect(() => {
    refresh(page, rowsPerPage);
  }, [page, rowsPerPage]);

  return (
    <DataTable
      loading={loading}
      pagination
      page={page}
      count={count || 0}
      rowsPerPage={rowsPerPage}
      onChangePage={onChangePage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      data={data}
      columns={[
        {
          id: 'itemName',
          label: <FormattedMessage id={'transaction.item.name'} />,
        },
        {
          id: 'quantity',
          label: <FormattedMessage id={'transaction.item.quantity'} />,
          align: 'right',
        },
        {
          id: 'grossAmount',
          label: <FormattedMessage id={'transaction.grossAmount'} />,
          align: 'right',
        },
      ]}
      template={({ item_name, grossAmount, quantity }) => {
        return (
          <>
            <TableCell>{item_name}</TableCell>
            <TableCell style={{ textAlign: 'right' }}>
              <FormattedNumber value={quantity || 0} />
            </TableCell>
            <TableCell style={{ textAlign: 'right' }}>
              <FormattedNumber value={grossAmount || 0} currency={'CZK'} {...{ style: 'currency' }} />
            </TableCell>
          </>
        );
      }}
    />
  );
};

export default ItemsList;
